import { Trans } from 'react-i18next'
import { TooltipText } from './styles'

const planScores: any = {
  'essentials-plan-monthly': '--',
  'growth-plan-monthly': 2,
  'growth-plan-annual': 2,
  'business-plan-annual': 30,
  'business-plan-monthly': 30,
  'business-plan-special': 30,
  'growth-plan-monthly-coupon-wbrothers': 2
}

const getPercentage = (usage: number, total: number | string) => {
  if (typeof total === 'number') return Math.floor((usage / total) * 100)

  return 0
}

const tooltipMessage = (percentage: number, plan: string) => {
  if (plan === 'essentials-plan-monthly') {
    return (
      <Trans i18nKey="l.essentials.tooltip.text">
        <TooltipText>
          <strong>No reports included in Essentials Plan</strong>
          <br />
          To unlock more reports, please upgrade your plan or view an application.
        </TooltipText>
      </Trans>
    )
  }

  if (percentage === 100) {
    return (
      <Trans i18nKey="l.essentials.tooltip.no_more.text">
        <TooltipText>
          <strong>No Trust Score Reports Remaining</strong>
          <br />
          To unlock more reports, please upgrade your plan or view an application.
        </TooltipText>
      </Trans>
    )
  } else {
    return (
      <Trans i18nKey="l.essentials.tooltip.almost_out.text">
        <TooltipText>
          <strong>You're almost out of reports</strong>
          <br />
          To unlock more reports, please upgrade your plan or view an application.
        </TooltipText>
      </Trans>
    )
  }
}

const showWarning = (used: number, total: number): boolean => {
  if (total - used <= 1) return true
  if (Math.floor(used / total) * 100 >= 80) return true

  return false
}

export { planScores, getPercentage, tooltipMessage, showWarning }
